import { Box, Typography } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';

export const PasswordSuccessRecoveryComponent = () => {
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate('/');
    }
    return (
        <>
            <Typography variant={'h4'} sx={{ fontSize: '1.6rem', fontWeight: 700, letterSpacing: '-0.02em', color: 'var(--foreground)', fontFamily: 'Poppins' }}>
                ¡Contraseña cambiada!
            </Typography>
            <Typography variant={'subtitle1'} sx={{ fontSize: '0.9rem', fontWeight: 400, color: 'var(--muted-foreground)' }}>
                Su contraseña se ha cambiado con éxito
            </Typography>
            <Box
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'center'}
                alignItems={'flex-start'}
                gap={1.5}
                sx={{
                    width: '100%',
                    padding: '5px 20px',
                }}
            >
                <Typography variant={'subtitle1'} sx={{ fontSize: '0.9rem', fontWeight: 400, cursor: 'pointer', alignSelf: 'center' }}>
                    <span
                        style={{ color: '#0DA15A', fontWeight: 600 }}
                        onClick={handleBackClick}
                    >
                        Ir a login
                    </span>
                </Typography>
            </Box>
        </>
    )
}
